/**
 * Event utilities e custom events
 */

/**
 * Dispatch custom event
 * @param {HTMLElement} element - Elemento da cui dispatchare
 * @param {string} eventName - Nome dell'evento
 * @param {*} detail - Dati dell'evento
 */
export function dispatchCustomEvent(element, eventName, detail = {}) {
  const event = new CustomEvent(eventName, {
    detail,
    bubbles: true,
    composed: true
  });
  element.dispatchEvent(event);
}

/**
 * Aspetta che un evento si verifichi
 * @param {string} eventName - Nome dell'evento
 * @param {number} timeout - Timeout in ms
 * @returns {Promise} Promise che risolve quando l'evento si verifica
 */
export function waitForEvent(eventName, timeout = 5000) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      window.removeEventListener(eventName, handler);
      reject(new Error(`Timeout waiting for ${eventName}`));
    }, timeout);
    
    const handler = (event) => {
      clearTimeout(timer);
      window.removeEventListener(eventName, handler);
      resolve(event);
    };
    
    window.addEventListener(eventName, handler);
  });
}

/**
 * Verifica se un evento è già stato dispatchato
 * @param {string} eventName - Nome dell'evento (es. 'sasha:themeManagerReady')
 * @returns {boolean} True se l'evento è già stato dispatchato
 */
export function isEventReady(eventName) {
  // Converti nome evento in flag window (es. sasha:themeManagerReady -> SashaThemeManagerReady)
  const flagName = eventName
    .split(':')
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join('');
  
  return window[flagName] === true;
}

